import React from 'react'
import i18n from 'i18next'
import Modal from './Modal'
import Button from './Button'
import './styles/alertModal.scss'

const AlertModal = (props) => {
    const {
        show,
        cssClass,
        content,
        noLabel,
        yesLabel,
        onNo,
        onYes,
        onCancel,
        hideCancel,
    } = props

    let componentClass = 'alert-modal'
    componentClass += cssClass ? ` ${cssClass}` : ''

    return (
        <Modal
            show={show}
            modalBgClass="alert-modal-bg"
            cssClass={componentClass}
            onClose={onCancel}
            nestedModal
        >
            <div className="uc-modal__header">
                <p className="uc-modal__desc">
                    {content}
                </p>
            </div>
            <div className="uc-modal__button-panel">
                {onCancel && !hideCancel && (
                    <Button
                        label={i18n.t('cancel')}
                        cssClass="regular error"
                        onClick={onCancel}
                    />
                )}
                <Button
                    label={noLabel}
                    cssClass="regular tertiary"
                    onClick={onNo}
                />
                {yesLabel && (
                    <Button
                        label={yesLabel}
                        cssClass="regular primary"
                        onClick={onYes}
                    />
                )}
            </div>
        </Modal>
    )
}

export default AlertModal
